import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@sick-bust-sts/sts-core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.css' ]
})
export class LoginComponent implements OnInit {

  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    if (this.authenticationService.isLoggedIn()) {
      this.router.navigate(['home']).then(() => {});
    }
  }

  public onClick(): void {
    this.login();
  }

  public onKeyUp(event: KeyboardEvent) {
    if (event.key !== 'Enter') {
      return;
    }

    this.login();
  }

  private login() {
    this.authenticationService.startAuthentication().then(() => {});
  }
}
